import { useMutation, useQueryClient } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";

export default function useQuoteAmends(quoteId: string) {
  const { patch } = useApiHelper();
  const queryClient = useQueryClient();

  const amendPrice = useMutation(
    (amendedPrice: number) =>
      patch(`/quote/${quoteId}/amend/price`, { amendedPrice }),
    {
      onSuccess: () => {
        // pick whichever keys you actually use in useSingleQuote
        queryClient.invalidateQueries(["quote", quoteId]);
        queryClient.invalidateQueries(["quotes"]);
      },
    }
  );

  const amendContact = useMutation(
    (amendedContact: { fullname: string; email: string; phone: string }) =>
      patch(`/quote/${quoteId}/amend/contact`, amendedContact),
    {
      onSuccess: () => {
        // pick whichever keys you actually use in useSingleQuote
        queryClient.invalidateQueries(["quote", quoteId]);
        queryClient.invalidateQueries(["quotes"]);
      },
    }
  );

  const amendPayment = useMutation(
    (amendedPayment: { bankAccountName: string, accountNumber: string, sortCode: string }) =>
      patch(`/quote/${quoteId}/amend/payment`, amendedPayment),
    {
      onSuccess: () => {
        // pick whichever keys you actually use in useSingleQuote
        queryClient.invalidateQueries(["quote", quoteId]);
        queryClient.invalidateQueries(["quotes"]);
      },
    }
  );

  return { 
    amendPrice, 
    amendContact,
    amendPayment
  };
}